<template>
  <div></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import useAuthentication from "@/hooks/use-authentication";

export default defineComponent({
  name: "LogoutPage",

  setup() {
    const { logout } = useAuthentication();
    logout();
  },
});
</script>
